import { render, staticRenderFns } from "./ProductVariantPopup.vue?vue&type=template&id=45b7af4c&scoped=true&"
import script from "./ProductVariantPopup.vue?vue&type=script&lang=js&"
export * from "./ProductVariantPopup.vue?vue&type=script&lang=js&"
import style0 from "./ProductVariantPopup.vue?vue&type=style&index=0&id=45b7af4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b7af4c",
  null
  
)

export default component.exports